import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, WhatsappLogo } from "@phosphor-icons/react";
import AnimatedSection from "@/components/layout/AnimatedSection";
import { services, fadeUp, WHATSAPP_QUOTE_URL } from "@/data/site";

const Services = () => {
  return (
    <AnimatedSection id="servicos" className="section-padding bg-white">
      <div className="container-custom">
        <motion.div variants={fadeUp} className="text-center mb-10">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E73336] mb-4 block">
            Nossos Serviços
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#234D89] mb-4">
            Soluções Completas em Acabamentos
          </h2>
          <div className="section-divider mx-auto mb-6" />
          <p className="text-[#5C5C5C] max-w-2xl mx-auto">
            Oferecemos uma linha completa de serviços de acabamento gráfico para atender todas as suas necessidades.
          </p>
        </motion.div>

        {/* Resumo escaneável: responde "vocês fazem X?" sem precisar rolar. */}
        <motion.nav
          variants={fadeUp}
          aria-label="Lista de serviços"
          data-testid="services-chips"
          className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-12"
        >
          {services.map((service) => (
            <a
              key={service.title}
              href={`#${service.slug}`}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#F5F5F5] text-[#234D89] text-xs sm:text-sm font-semibold hover:bg-[#234D89] hover:text-white transition-colors"
            >
              <service.icon size={16} weight="duotone" />
              {service.title}
            </a>
          ))}
        </motion.nav>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {services.map((service, index) => (
            <motion.article
              key={service.title}
              id={service.slug}
              variants={fadeUp}
              custom={index}
              data-testid={`service-card-${index}`}
              className="service-card scroll-mt-28 bg-white border border-gray-200 rounded-2xl overflow-hidden group flex flex-col"
            >
              <div className="relative aspect-[4/3] sm:aspect-[16/10] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#234D89]/70 via-transparent to-transparent" />
              </div>

              <div className="p-4 sm:p-7 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-2 sm:mb-3">
                  <div className="hidden sm:flex w-11 h-11 bg-[#F5F5F5] rounded-xl items-center justify-center flex-shrink-0 group-hover:bg-[#E73336] transition-colors">
                    <service.icon
                      size={24}
                      weight="duotone"
                      className="text-[#234D89] group-hover:text-white transition-colors"
                    />
                  </div>
                  <h3 className="text-sm sm:text-lg font-semibold text-[#234D89] leading-snug">
                    {service.title}
                  </h3>
                </div>
                <p className="text-[#5C5C5C] leading-relaxed text-xs sm:text-sm">
                  {service.description}
                </p>
              </div>
            </motion.article>
          ))}
        </div>

        {/* CTA */}
        <motion.div variants={fadeUp} className="text-center mt-12">
          <p className="text-[#5C5C5C] mb-6">
            Precisa de um acabamento específico? <strong className="text-[#234D89]">Fale com a gente.</strong>
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={WHATSAPP_QUOTE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="services-cta-whatsapp"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#E73336] text-white font-bold text-sm uppercase tracking-wide rounded-full hover:bg-[#BD2A2C] transition-all btn-cta"
            >
              <WhatsappLogo weight="fill" size={22} />
              Solicitar Orçamento
            </a>
            <Link
              to="/galeria"
              data-testid="services-cta-gallery"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#F5F5F5] text-[#234D89] font-bold text-sm uppercase tracking-wide rounded-full hover:bg-[#E5E5E5] transition-all"
            >
              Ver Galeria de Trabalhos
              <ArrowRight size={18} />
            </Link>
          </div>
        </motion.div>
      </div>
    </AnimatedSection>
  );
};

export default Services;
